import { render, staticRenderFns } from "./admin_shell.vue?vue&type=template&id=7136960e&scoped=true&"
import script from "./admin_shell.vue?vue&type=script&lang=js&"
export * from "./admin_shell.vue?vue&type=script&lang=js&"
import style0 from "./admin_shell.vue?vue&type=style&index=0&id=7136960e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7136960e",
  null
  
)

export default component.exports